var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52 104C80.7188 104 104 80.7188 104 52C104 23.2812 80.7188 0 52 0C23.2812 0 0 23.2812 0 52C0 80.7188 23.2812 104 52 104Z",
    fill: "#1363DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104 52C104 49.6767 103.848 47.3891 103.552 45.1464L84.1175 25.3595L83.6824 26.0749L77.1205 19.161L73.7208 30.7192L62.5148 19.161L59.9869 31.591L47.9091 19.161L45.4675 31.5768L33.3032 19.161L19.8827 82.4373L40.0705 102.625C43.901 103.524 47.8948 104 52 104C80.7188 104 104 80.7188 104 52V52Z",
    fill: "#498BF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8825 25.3595V36.8024L52 46.4271L52.4132 46.3034L54.1643 34.6503L52.063 25.3595H19.8825Z",
    fill: "#044CBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1175 25.3595H52.063V46.4084L84.1175 36.8024V25.3595Z",
    fill: "#0E5DD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8825 36.8024V82.4373H52.063L54.1643 59.1977L52.4132 36.8024H19.8825Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.063 36.8024H84.1175V82.4375H52.063V36.8024Z",
    fill: "#E9EDF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8795 19.161H33.303V31.0948H26.8795V19.161Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4852 19.161H47.9089V31.0948H41.4852V19.161Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0911 19.161H62.5148V31.0948H56.0911V19.161Z",
    fill: "#E9EDF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6971 19.161H77.1205V31.0948H70.6971V19.161Z",
    fill: "#E9EDF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0351 42.9095H35.6058V50.4802H28.0351V42.9095Z",
    fill: "#636978"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4881 42.9095H49.0588V50.4802H41.4881V42.9095Z",
    fill: "#636978"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9413 42.9095H62.5119V50.4802H54.9413V42.9095Z",
    fill: "#414952"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3944 42.9095H75.9651V50.4802H68.3944V42.9095Z",
    fill: "#414952"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0351 67.9155H35.6058V75.4861H28.0351V67.9155Z",
    fill: "#636978"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4881 67.9155H49.0588V75.4861H41.4881V67.9155Z",
    fill: "#636978"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9413 67.9155H62.5119V75.4861H54.9413V67.9155Z",
    fill: "#414952"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3944 67.9155H75.9651V75.4861H68.3944V67.9155Z",
    fill: "#414952"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0351 55.4125H35.6058V62.9832H28.0351V55.4125Z",
    fill: "#636978"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4881 55.4125H49.0588V62.9832H41.4881V55.4125Z",
    fill: "#636978"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9413 55.4125H62.5119V62.9832H54.9413V55.4125Z",
    fill: "#FF73A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3944 55.4125H75.9651V62.9832H68.3944V55.4125Z",
    fill: "#FF73A5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon-1.710e538935395ee8e89f2f60fb9274fd.svg";
export { ForwardRef as ReactComponent };